import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromGraphql from "./citizens-services.graphql";
import * as fromActions from "./citizens-services.actions";
import {map, switchMap} from 'rxjs';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {PaginationService} from "../../../../services/pagination.service";
import {GET_CITIZEN_SERVICES_FEW} from "./citizens-services.graphql";


@Injectable()
export class CitizensServicesEffects {

  citizenGetServicesFromSector$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenGetServicesFromSector),
    switchMap((action) => {
      return this.apollo.query({
        query: action?.showFew ? fromGraphql.GET_CITIZEN_SERVICES_SECTOR_FEW : fromGraphql.GET_CITIZEN_SERVICES_SECTOR,
        fetchPolicy: 'network-only',
        variables: {
          sectorUniqueId: action?.sectorUniqueId,
          filtering: {
            pageNumber: action?.pageNumber,
            itemsPerPage: action?.itemsPerPage
          }
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching  Services '),
        map(({data}: any) => {
          if (data) {
            const result: any = data?.citizenGetServicesFromSector;
            if (result?.response?.status) {
              this.paginationService.setPage({...result?.page, itemsPerPage: action?.itemsPerPage});
              this.store.dispatch(fromActions.loadCitizensServicess({citizensServicess: result?.data}))
            } else {
              this.store.dispatch(fromActions.loadCitizensServicess({citizensServicess: []}))
            }
          }
        })
      );
    })
  ), {dispatch: false});

  citizenGetServicesFromSocialGroup = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenGetServicesFromSocialGroup),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_CITIZEN_SERVICES_FROM_SOCIAL_GROUPS,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching citizen services'),
        map(({data}: any) => {
          if (data) {
            const result: any = data?.citizenGetServicesFromSocialGroups
            if (result?.response?.status) {
              this.paginationService.setPage({...result?.page, itemsPerPage: action?.filtering.itemsPerPage})
              this.store.dispatch(fromActions.loadCitizensServicess({citizensServicess: result?.data}))
            }
          }
        })
      );
    })
  ), {dispatch: false});


  citizenGetServices$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenGetServices),
    switchMap((action) => {
      return this.apollo.query({
        query: action?.showFew ? fromGraphql.GET_CITIZEN_SERVICES_FEW : fromGraphql.GET_CITIZEN_SERVICES,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action?.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching service categories'),
        map(({data}: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.status) {
              this.paginationService.setPage({...result?.page, itemsPerPage: action?.filtering?.itemsPerPage})
              this.store.dispatch(fromActions.loadCitizensServicess({citizensServicess: result?.data}))
            } else {
              this.store.dispatch(fromActions.loadCitizensServicess({citizensServicess: []}))
            }
          }
        })
      );
    })
  ), {dispatch: false});


  getCitizenRequestedServices$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getCitizenRequestedServices),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_REQUESTED_SERVICES,
        fetchPolicy: 'network-only'
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching services'),
        map(({data}: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            result?.response?.status ? this.store.dispatch(fromActions.loadCitizensServicess({citizensServicess: result?.data})) : []
          }
        })
      );
    })
  ), {dispatch: false});

  citizenGetAllServicesByLocation$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenGetAllServicesByLocation),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.CITIZEN_GET_ALL_SERVICES_BY_LOCATION,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action?.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching service categories'),
        map(({data}: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.status) {
              this.paginationService.setPage({...result?.page, itemsPerPage: action?.filtering?.itemsPerPage})
              this.store.dispatch(fromActions.loadCitizensServicess({citizensServicess: result?.data}))
            } else {
              this.store.dispatch(fromActions.loadCitizensServicess({citizensServicess: []}))
            }
          }
        })
      );
    })
  ), {dispatch: false});

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private paginationService: PaginationService,
    private responseCodesService: ResponseCodeService
  ) {
  }
}
